export default {
  // mdg列表
  QUERY_MDG_PAGE: '/maindata/mdgSendInfo/queryPage',
};
